import { $, YO, aviso, avisoHtml, el, esc, limpiar, noContesto, puede, rpc, rpcLee } from './nucleo';

//  VACACIONES, paso 1 (D224, migración 0104). Arriba, «Mis vacaciones»: lo
//  ve cualquiera (`mis_vacaciones`). Abajo, para quien tiene
//  `vacaciones.configurar` (el dueño y el admin global): los días de cada
//  empleado, los grupos de cobertura, los backups y los períodos bloqueados,
//  todo de `vacaciones_panel` y escrito por sus funciones. La pantalla no
//  calcula nada: los días y los miembros de cada grupo los da la base.
//
//  PASO 2 (D226, migración 0106): cada empleado pide vacaciones o un día
//  suelto (`revisar_vacaciones` dice los días, el saldo y los AVISOS antes de
//  mandarlo; `pedir_vacaciones` lo guarda) y ve sus pedidos; quien tiene
//  `vacaciones.aprobar` (el dueño y el admin global) aprueba o rechaza lo de
//  los demás, carga vacaciones directo a otra persona y cancela las
//  aprobadas. Los avisos los calcula la base: la pantalla los muestra.
//
//  PASO 3 (D227, migración 0107): la ENFERMEDAD es un tipo más (se pide y se
//  aprueba, no descuenta); el saldo trae LO ACUMULADO del año anterior,
//  partido en lo del año (verde), lo acumulado (amarillo) y lo que pasa del
//  tercio (rojo), todo calculado por la base; y el CALENDARIO del mes
//  (`vacaciones_calendario`: quien aprueba ve a todos, cada uno a los de sus
//  grupos).

const configura = () => puede('vacaciones', 'configurar');
const aprueba = () => puede('vacaciones', 'aprobar');
const hoyAnio = () => new Date().getFullYear();

let PANEL: any = null;
let TURNO_MIAS = 0, TURNO_PANEL = 0;   //  una lectura vieja no pinta encima de una nueva
let GRUPO: number | null = null;          //  el grupo del formulario; null: alta
let BLOQUEO: number | null = null;        //  el período del formulario; null: alta
//  Las personas tocadas a mano en el formulario del grupo: id → true
//  (agregada) o false (sacada). Lo que no está acá lo decide el rol.
let A_MANO = new Map<number, boolean>();
//  Si se tocó la lista de personas: si no, no se manda (y lo que la base ya
//  tiene a mano queda como está, aunque el formulario no lo muestre).
let TOCO_PERSONAS = false;

const ddmmaaaa = (iso: string | null | undefined) =>
  iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '—';
const nombreRol = (c: string) => (PANEL?.roles || []).find((r: any) => r.codigo === c)?.nombre ?? c;
const nombres = (ids: number[]) => (ids || []).map(id => nombreDe(id)).sort((a, b) => a.localeCompare(b)).join(', ');
const nombreDe = (id: number) => (PANEL?.empleados || []).find((e: any) => Number(e.id) === Number(id))?.nombre ?? '¿?';
const chipDias = (d: any) => {
  if (!d) return '<span class="chip c-bad">sin dato</span>';
  const cls = d.provisorio || d.origen === 'a_mano' ? 'c-warn' : d.origen === 'proporcional' ? 'c-info' : 'c-ok';
  const que = d.origen === 'a_mano' ? 'a mano, provisorio' : d.origen === 'alta' ? 'provisorio'
            : d.origen === 'proporcional' ? 'proporcional' : 'por antigüedad';
  return `<span class="chip ${cls}"><b>${esc(d.dias)}</b> días · ${esc(que)}</span>`;
};

export async function cargarVacaciones(){
  leerMias();
  for (const c of ['#cardVacEmpleados', '#cardVacGrupos', '#cardVacBackups', '#cardVacBloqueos'])
    $(c).classList.toggle('oculto', !configura());
  if (configura()) leerPanel();
  $('#cardVacAprobar').classList.toggle('oculto', !aprueba());
  if (aprueba()) leerAprobar(); else contador(0);
}

async function leerMias(){
  leerCalendario();   //  lo que cambia lo mío cambia el calendario
  const turno = ++TURNO_MIAS;
  const { data, error } = await rpcLee('mis_vacaciones', {});
  if (turno !== TURNO_MIAS) return;
  if (error){
    $('#misVac').innerHTML = `<p class="vacio">No se pudieron leer tus días (${esc(error.message)}).</p>`;
    $('#formVacPedir').classList.add('oculto');
    $('#misPedidosBox').classList.add('oculto');
    return;
  }
  const m: any = data || {};
  if (!m.empleado){
    $('#misVac').innerHTML = '<p>No figurás como empleado (sos el dueño o tu usuario está inactivo): no tenés días de vacaciones en el sistema.</p>';
    $('#formVacPedir').classList.add('oculto');
    $('#misPedidosBox').classList.add('oculto');
    return;
  }
  const d = m.dias || {};
  const sa = m.saldo || {};
  $('#misVac').innerHTML = `
    <p>En <b>${esc(m.anio)}</b> te corresponden ${chipDias(d)}</p>
    <p class="hint">${esc(d.detalle || '')}</p>
    <p id="misSaldo">${saldoTexto(sa, 'te')}</p>
    <p class="hint">${(m.grupos || []).length ? `Tu grupo: <b>${esc(m.grupos.join(', '))}</b>.` : 'No estás en ningún grupo de cobertura.'}
       ${(m.backups || []).length ? ` Te cubre: <b>${esc(m.backups.join(', luego '))}</b>.` : ''}</p>`;
  $('#formVacPedir').classList.remove('oculto');
  $('#misPedidosBox').classList.remove('oculto');
  pintarMisPedidos(m.pedidos || []);
}

async function leerPanel(){
  const turno = ++TURNO_PANEL;
  const sel = $('#vacAnio');
  if (!sel.options.length){
    const a = hoyAnio();
    sel.innerHTML = [a - 1, a, a + 1].map(x => `<option value="${x}"${x === a ? ' selected' : ''}>${x}</option>`).join('');
  }
  const { data, error } = await rpcLee('vacaciones_panel', { p_anio: Number(sel.value) });
  if (turno !== TURNO_PANEL) return;
  if (error){
    PANEL = null;
    const m = `<p class="vacio">No se pudo leer la configuración de vacaciones (${esc(error.message)}). No quiere decir que esté vacía.</p>`;
    for (const t of ['#tblVacEmpleados', '#tblVacGrupos', '#tblVacBackups', '#tblVacBloqueos'])
      $(t).innerHTML = `<tr><td colspan="6">${m}</td></tr>`;
    limpiar('#vacFaltan');
    return;
  }
  PANEL = data;
  pintarEmpleados(); pintarGrupos(); pintarBackups(); pintarBloqueos();
}
$('#vacAnio').onchange = () => leerPanel();

// ---------- los días de cada empleado ----------
function pintarEmpleados(){
  const es = PANEL.empleados || [];
  const faltan = es.filter((e: any) => !e.fecha_ingreso);
  if (faltan.length) aviso('#vacFaltan', 'warn',
    `Falta la fecha de ingreso de ${faltan.length === 1 ? '1 empleado' : faltan.length + ' empleados'} (${faltan.map((e: any) => e.nombre).join(', ')}): sus días son provisorios.`);
  else limpiar('#vacFaltan');
  $('#tblVacEmpleados').innerHTML = es.map((e: any) => `
    <tr data-emp="${e.id}">
      <td><b>${esc(e.nombre)}</b></td>
      <td>${esc((e.roles || []).map(nombreRol).join(', ') || '—')}</td>
      <td><input type="date" data-campo="fecha" value="${esc(e.fecha_ingreso || '')}" aria-label="Fecha de ingreso de ${esc(e.nombre)}"></td>
      <td><input type="number" min="0" max="365" step="1" data-campo="dias" value="${e.dias_provisorios ?? ''}"
                 style="max-width:6rem" aria-label="Días a mano de ${esc(e.nombre)}"${e.fecha_ingreso ? ' title="Con la fecha cargada, los días a mano no se usan"' : ''}></td>
      <td>${chipDias(e.dias)}<div class="hint">${esc(e.dias?.detalle || '')}</div></td>
      <td><button class="b b-sec" type="button" data-guardaremp="${e.id}">Guardar</button></td>
    </tr>`).join('') || '<tr><td colspan="6" class="vacio">No hay empleados activos.</td></tr>';
}
$('#tblVacEmpleados').onclick = async (ev: Event) => {
  const b = el(ev.target).closest('[data-guardaremp]');
  if (!b) return;
  limpiar('#vacEmpMsg');
  const id = Number(b.dataset.guardaremp);
  const e = (PANEL?.empleados || []).find((x: any) => Number(x.id) === id);
  const fila = b.closest('tr') as HTMLElement;
  const f = ($('[data-campo="fecha"]', fila).value || '').trim();
  const dRaw = ($('[data-campo="dias"]', fila).value || '').trim();
  const d: Record<string, unknown> = {};
  if (f !== (e?.fecha_ingreso || '')) d.fecha_ingreso = f;
  if (dRaw !== String(e?.dias_provisorios ?? '')) d.dias_provisorios = dRaw === '' ? null : dRaw;
  if (!Object.keys(d).length){ aviso('#vacEmpMsg', 'ok', 'No cambiaste nada.'); return; }
  b.disabled = true;
  const { data, error } = await rpc('guardar_datos_vacaciones', { p_usuario_id: id, p_datos: d as any });
  b.disabled = false;
  if (noContesto(error)){ aviso('#vacEmpMsg', 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista antes de repetirlo.'); leerPanel(); return; }
  if (error){ aviso('#vacEmpMsg', 'bad', error.message); return; }
  //  La fecha de ingreso cambia los días y lo acumulado de la lista de
  //  cargar directo.
  await leerPanel(); leerMias(); if (aprueba()) leerAprobar();
  aviso('#vacEmpMsg', 'ok', (data as any).mensaje);
};

// ---------- los grupos ----------
function pintarGrupos(){
  const gs = PANEL.grupos || [];
  $('#tblVacGrupos').innerHTML = gs.map((g: any) => `
    <tr>
      <td><b>${esc(g.nombre)}</b>${g.activo ? '' : ' <span class="chip c-warn">inactivo</span>'}</td>
      <td class="num">${esc(g.max_ausentes)}</td>
      <td>${esc((g.roles || []).map(nombreRol).join(', ') || '—')}</td>
      <td>${esc(nombres(g.miembros) || 'nadie')}${
        (g.agregados || []).length ? `<div class="hint">Agregados a mano: ${esc(nombres(g.agregados))}</div>` : ''}${
        (g.sacados || []).length ? `<div class="hint">Sacados a mano: ${esc(nombres(g.sacados))}</div>` : ''}</td>
      <td><button class="b b-sec" type="button" data-editgrupo="${g.id}">Cambiar</button></td>
    </tr>`).join('') || '<tr><td colspan="5" class="vacio">Todavía no hay grupos.</td></tr>';
  //  Si el formulario estaba abierto sobre un grupo que ya no está, se cierra.
  if (GRUPO != null && !gs.some((g: any) => Number(g.id) === GRUPO)) cerrarGrupo();
  pintarGruposDeBloqueo();
}
$('#tblVacGrupos').onclick = (ev: Event) => {
  const b = el(ev.target).closest('[data-editgrupo]');
  if (b) abrirGrupo(Number(b.dataset.editgrupo));
};
$('#btnVacGrupoNuevo').onclick = () => abrirGrupo(null);
$('#vgCancelar').onclick = () => cerrarGrupo();

function cerrarGrupo(){ GRUPO = null; $('#formVacGrupo').classList.add('oculto'); }

function rolesElegidos(): string[] {
  return Array.from(document.querySelectorAll<HTMLInputElement>('#vgRoles input:checked')).map(i => i.value);
}
function entraPorRol(e: any, roles: string[]){ return (e.roles || []).some((r: string) => roles.includes(r)); }

function pintarPersonasDelGrupo(){
  const roles = rolesElegidos();
  $('#vgPersonas').innerHTML = (PANEL.empleados || []).map((e: any) => {
    const porRol = entraPorRol(e, roles);
    const mano = A_MANO.get(Number(e.id));
    const dentro = mano ?? porRol;
    const nota = mano === true ? ' <span class="hint">(a mano)</span>' : mano === false ? ' <span class="hint">(sacado a mano)</span>' : '';
    return `<label><input type="checkbox" value="${e.id}"${dentro ? ' checked' : ''}> ${esc(e.nombre)}${nota}</label>`;
  }).join('') || '<span class="hint">No hay empleados activos.</span>';
}

function abrirGrupo(id: number | null){
  if (!PANEL) return;
  GRUPO = id;
  limpiar('#vgMsg');
  const g = id == null ? null : (PANEL.grupos || []).find((x: any) => Number(x.id) === id);
  $('#vgTit').textContent = g ? `Grupo «${g.nombre}»` : 'Nuevo grupo';
  $('#vgNombre').value = g?.nombre || '';
  $('#vgMax').value = g ? String(g.max_ausentes) : '1';
  $('#vgActivo').checked = g ? !!g.activo : true;
  $('#vgActivoLbl').classList.toggle('oculto', !g);
  $('#vgBorrar').classList.toggle('oculto', !g);
  $('#vgGuardar').textContent = g ? 'Guardar' : 'Crear el grupo';
  $('#vgRoles').innerHTML = (PANEL.roles || []).map((r: any) =>
    `<label><input type="checkbox" value="${esc(r.codigo)}"${(g?.roles || []).includes(r.codigo) ? ' checked' : ''}> ${esc(r.nombre)}</label>`).join('');
  A_MANO = new Map();
  TOCO_PERSONAS = false;
  for (const u of g?.agregados || []) A_MANO.set(Number(u), true);
  for (const u of g?.sacados || []) A_MANO.set(Number(u), false);
  pintarPersonasDelGrupo();
  $('#formVacGrupo').classList.remove('oculto');
  $('#formVacGrupo').scrollIntoView({ block: 'nearest' });
  $('#vgNombre').focus();
}
$('#vgRoles').onchange = () => pintarPersonasDelGrupo();
$('#vgPersonas').onchange = (ev: Event) => {
  const i = ev.target as HTMLInputElement;
  const e = (PANEL?.empleados || []).find((x: any) => Number(x.id) === Number(i.value));
  if (!e) return;
  TOCO_PERSONAS = true;
  //  Si queda como lo decide el rol, deja de estar «a mano».
  if (i.checked === entraPorRol(e, rolesElegidos())) A_MANO.delete(Number(e.id));
  else A_MANO.set(Number(e.id), i.checked);
  pintarPersonasDelGrupo();
};

$('#formVacGrupo').onsubmit = async (ev: Event) => {
  ev.preventDefault();
  limpiar('#vgMsg');
  const g = GRUPO == null ? null : (PANEL?.grupos || []).find((x: any) => Number(x.id) === GRUPO);
  const roles = rolesElegidos();
  const d: Record<string, unknown> = {
    nombre: ($('#vgNombre').value || '').trim(),
    max_ausentes: ($('#vgMax').value || '').trim(),
  };
  //  Los roles: los que el formulario no ofrece (un rol desactivado) se
  //  conservan; y si no cambiaron, no se mandan.
  const ofrecidos = (PANEL?.roles || []).map((r: any) => r.codigo);
  const rolesFinal = [...roles, ...((g?.roles || []).filter((c: string) => !ofrecidos.includes(c)))];
  const mismos = (a: string[], b: string[]) => a.length === b.length && a.every(x => b.includes(x));
  if (!g || !mismos(rolesFinal, g.roles || [])) d.roles = rolesFinal;
  //  Las personas, sólo si se tocaron. Lo que se manda a mano son sólo las
  //  excepciones al rol, más las que la base tiene de gente que el
  //  formulario no muestra (inactiva).
  if (!g || TOCO_PERSONAS){
    const agregados: number[] = [], sacados: number[] = [];
    const listados = new Set((PANEL?.empleados || []).map((e: any) => Number(e.id)));
    for (const e of PANEL?.empleados || []){
      const m = A_MANO.get(Number(e.id));
      if (m === true && !entraPorRol(e, roles)) agregados.push(Number(e.id));
      if (m === false && entraPorRol(e, roles)) sacados.push(Number(e.id));
    }
    for (const u of g?.agregados || []) if (!listados.has(Number(u))) agregados.push(Number(u));
    for (const u of g?.sacados || []) if (!listados.has(Number(u))) sacados.push(Number(u));
    d.agregados = agregados; d.sacados = sacados;
  }
  if (g) d.activo = $('#vgActivo').checked;
  const b = $('#vgGuardar'); b.disabled = true;
  const { data, error } = await rpc('guardar_grupo_cobertura', { p_grupo_id: GRUPO as any, p_datos: d as any });
  b.disabled = false;
  if (noContesto(error)){ aviso('#vgMsg', 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista antes de repetirlo.'); leerPanel(); return; }
  if (error){ aviso('#vgMsg', 'bad', error.message); return; }
  cerrarGrupo();
  await leerPanel(); leerMias();
  aviso('#vacGruposMsg', 'ok', (data as any).mensaje);
};

$('#vgBorrar').onclick = async () => {
  if (GRUPO == null) return;
  const g = (PANEL?.grupos || []).find((x: any) => Number(x.id) === GRUPO);
  if (!confirm(`¿Borrar el grupo «${g?.nombre ?? ''}»?`)) return;
  const { data, error } = await rpc('borrar_grupo_cobertura', { p_grupo_id: GRUPO });
  if (noContesto(error)){ aviso('#vgMsg', 'warn', error.message + ' No se sabe si se borró: fijate en la lista.'); leerPanel(); return; }
  if (error){ aviso('#vgMsg', 'bad', error.message); return; }
  cerrarGrupo();
  await leerPanel(); leerMias();
  aviso('#vacGruposMsg', 'ok', (data as any).mensaje);
};

// ---------- los backups ----------
function pintarBackups(){
  const es = PANEL.empleados || [];
  const opciones = (yo: number, elegido: number | undefined) => `<option value="">—</option>` +
    es.filter((x: any) => Number(x.id) !== yo).map((x: any) =>
      `<option value="${x.id}"${Number(x.id) === Number(elegido) ? ' selected' : ''}>${esc(x.nombre)}</option>`).join('');
  $('#tblVacBackups').innerHTML = es.map((e: any) => `
    <tr data-emp="${e.id}">
      <td><b>${esc(e.nombre)}</b></td>
      ${[0, 1, 2].map(i => `<td><select data-orden="${i}" aria-label="Backup ${i + 1} de ${esc(e.nombre)}">${opciones(Number(e.id), (e.backups || [])[i])}</select></td>`).join('')}
      <td><button class="b b-sec" type="button" data-guardarbk="${e.id}">Guardar</button></td>
    </tr>`).join('') || '<tr><td colspan="5" class="vacio">No hay empleados activos.</td></tr>';
}
$('#tblVacBackups').onclick = async (ev: Event) => {
  const b = el(ev.target).closest('[data-guardarbk]');
  if (!b) return;
  limpiar('#vacBackupsMsg');
  const fila = b.closest('tr') as HTMLElement;
  const lista = [0, 1, 2].map(i => ($(`[data-orden="${i}"]`, fila).value || '')).filter(v => v !== '').map(Number);
  b.disabled = true;
  const { data, error } = await rpc('guardar_backups', { p_usuario_id: Number(b.dataset.guardarbk), p_backups: lista });
  b.disabled = false;
  if (noContesto(error)){ aviso('#vacBackupsMsg', 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista antes de repetirlo.'); leerPanel(); return; }
  if (error){ aviso('#vacBackupsMsg', 'bad', error.message); return; }
  await leerPanel(); leerMias();
  aviso('#vacBackupsMsg', 'ok', (data as any).mensaje);
};

// ---------- los períodos bloqueados ----------
function pintarGruposDeBloqueo(elegidos?: number[]){
  const ya = elegidos ?? Array.from(document.querySelectorAll<HTMLInputElement>('#vbGrupos input:checked')).map(i => Number(i.value));
  $('#vbGrupos').innerHTML = (PANEL?.grupos || []).map((g: any) =>
    `<label><input type="checkbox" value="${g.id}"${ya.includes(Number(g.id)) ? ' checked' : ''}> ${esc(g.nombre)}</label>`).join('')
    || '<span class="hint">No hay grupos: el período vale para todos.</span>';
}
function pintarBloqueos(){
  const bs = PANEL.bloqueos || [];
  const nombreGrupo = (id: number) => (PANEL.grupos || []).find((g: any) => Number(g.id) === Number(id))?.nombre ?? '¿?';
  $('#tblVacBloqueos').innerHTML = bs.map((b: any) => `
    <tr>
      <td>${esc(ddmmaaaa(b.desde))}</td><td>${esc(ddmmaaaa(b.hasta))}</td>
      <td>${(b.grupos || []).length ? esc(b.grupos.map(nombreGrupo).join(', ')) : '<b>todos</b>'}</td>
      <td>${esc(b.motivo || '—')}</td>
      <td><div class="fila-acc">
        <button class="b b-sec" type="button" data-editbl="${b.id}">Cambiar</button>
        <button class="b b-sec" type="button" data-borrarbl="${b.id}">Borrar</button></div></td>
    </tr>`).join('') || '<tr><td colspan="5" class="vacio">No hay períodos bloqueados.</td></tr>';
  if (BLOQUEO != null && !bs.some((b: any) => Number(b.id) === BLOQUEO)) limpiarBloqueo();
}
function limpiarBloqueo(){
  BLOQUEO = null;
  $('#vbTit').textContent = 'Nuevo período';
  $('#vbGuardar').textContent = 'Agregar el período';
  $('#vbCancelar').classList.add('oculto');
  $('#vbDesde').value = ''; $('#vbHasta').value = ''; $('#vbMotivo').value = '';
  ($('#vbHasta') as unknown as HTMLInputElement).min = '';
  pintarGruposDeBloqueo([]);
}
$('#vbCancelar').onclick = () => { limpiar('#vbMsg'); limpiarBloqueo(); };
//  Al elegir el «desde», el calendario del «hasta» no ofrece días anteriores.
$('#vbDesde').onchange = () => { ($('#vbHasta') as unknown as HTMLInputElement).min = $('#vbDesde').value || ''; };
$('#tblVacBloqueos').onclick = async (ev: Event) => {
  const ed = el(ev.target).closest('[data-editbl]');
  const bo = el(ev.target).closest('[data-borrarbl]');
  if (ed){
    const b = (PANEL?.bloqueos || []).find((x: any) => Number(x.id) === Number(ed.dataset.editbl));
    if (!b) return;
    BLOQUEO = Number(b.id);
    limpiar('#vbMsg');
    $('#vbTit').textContent = `Cambiar el período del ${ddmmaaaa(b.desde)} al ${ddmmaaaa(b.hasta)}`;
    $('#vbGuardar').textContent = 'Guardar';
    $('#vbCancelar').classList.remove('oculto');
    $('#vbDesde').value = b.desde; $('#vbHasta').value = b.hasta; $('#vbMotivo').value = b.motivo || '';
    ($('#vbHasta') as unknown as HTMLInputElement).min = b.desde;
    pintarGruposDeBloqueo((b.grupos || []).map(Number));
    $('#formVacBloqueo').scrollIntoView({ block: 'nearest' });
    return;
  }
  if (bo){
    const b = (PANEL?.bloqueos || []).find((x: any) => Number(x.id) === Number(bo.dataset.borrarbl));
    if (!b || !confirm(`¿Borrar el período del ${ddmmaaaa(b.desde)} al ${ddmmaaaa(b.hasta)}?`)) return;
    limpiar('#vbMsg');
    const { data, error } = await rpc('borrar_bloqueo_vacaciones', { p_bloqueo_id: Number(b.id) });
    if (noContesto(error)){ aviso('#vbMsg', 'warn', error.message + ' No se sabe si se borró: fijate en la lista.'); leerPanel(); return; }
    if (error){ aviso('#vbMsg', 'bad', error.message); return; }
    await leerPanel(); leerCalendario();
    aviso('#vbMsg', 'ok', (data as any).mensaje);
  }
};
$('#formVacBloqueo').onsubmit = async (ev: Event) => {
  ev.preventDefault();
  limpiar('#vbMsg');
  const d = {
    desde: $('#vbDesde').value || '', hasta: $('#vbHasta').value || '',
    motivo: ($('#vbMotivo').value || '').trim(),
    grupos: Array.from(document.querySelectorAll<HTMLInputElement>('#vbGrupos input:checked')).map(i => Number(i.value)),
  };
  const b = $('#vbGuardar'); b.disabled = true;
  const { data, error } = await rpc('guardar_bloqueo_vacaciones', { p_bloqueo_id: BLOQUEO as any, p_datos: d as any });
  b.disabled = false;
  if (noContesto(error)){ aviso('#vbMsg', 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista antes de repetirlo.'); leerPanel(); return; }
  if (error){ aviso('#vbMsg', 'bad', error.message); return; }
  limpiarBloqueo();
  await leerPanel(); leerCalendario();
  aviso('#vbMsg', 'ok', (data as any).mensaje);
};

// ---------- paso 2 (D226): pedir, mis pedidos y aprobar ----------
let APROBAR: any = null;
let TURNO_APROBAR = 0;
const TURNO_REV: Record<string, number> = { vp: 0, vd: 0 };

const QUE = (p: any) => p.tipo === 'dia' ? 'Día suelto' : p.tipo === 'enfermedad' ? 'Enfermedad' : 'Vacaciones';
const fechas = (p: any) => p.desde === p.hasta ? ddmmaaaa(p.desde) : `${ddmmaaaa(p.desde)} al ${ddmmaaaa(p.hasta)}`;
const CHIP_ESTADO: Record<string, [string, string]> = {
  pedida: ['c-warn', 'esperando aprobación'], aprobada: ['c-ok', 'aprobada'], rechazada: ['c-bad', 'rechazada'],
  retirada: ['c-info', 'retirada'], cancelada: ['c-bad', 'cancelada'],
};
const chipEstado = (e: string) => { const [c, t] = CHIP_ESTADO[e] ?? ['c-info', e]; return `<span class="chip ${c}">${esc(t)}</span>`; };
//  «De 2027 te quedan 7 de 21 (14 aprobados, 0 pedidos)». Con lo acumulado
//  (D227), «de 21 y 11 acumulados de 2026», y de dónde sale lo que queda:
//  lo del año en verde, lo acumulado en amarillo y lo que pasa del tercio
//  en rojo (los números los da la base).
const plural = (n: number, uno: string, varios: string) => `${n} ${n === 1 ? uno : varios}`;
const saldoTexto = (sa: any, quien: 'te' | 'le') => {
  if (!sa || sa.anio == null) return '';
  const acu = Number(sa.acumulado || 0);
  const partes = acu > 0 ? [
    Number(sa.quedan_anio) > 0 ? `<span class="chip c-ok">${esc(plural(Number(sa.quedan_anio), 'del año', 'del año'))}</span>` : '',
    Number(sa.quedan_acumulado) > 0 ? `<span class="chip c-warn">${esc(plural(Number(sa.quedan_acumulado), 'acumulado', 'acumulados'))} de ${esc(sa.acumulado_de)}</span>` : '',
    Number(sa.quedan_excede) > 0 ? `<span class="chip c-bad" title="La ley deja acumular hasta un tercio de los días del año anterior (${esc(sa.tercio)}): lo que pasa se puede usar, pero va en rojo.">${esc(plural(Number(sa.quedan_excede), 'pasa', 'pasan'))} del tercio</span>` : '',
  ].filter(x => x).join(' ') : '';
  return `<span class="saldo-vac">De <b>${esc(sa.anio)}</b> ${quien} ${Number(sa.quedan) === 1 ? 'queda' : 'quedan'} <b>${esc(Math.max(Number(sa.quedan), 0))}</b> de ${esc(sa.corresponden)} días${
      acu > 0 ? `, más ${esc(plural(acu, 'acumulado', 'acumulados'))} de ${esc(sa.acumulado_de)}` : ''}${
      Number(sa.quedan) < 0 ? ` (se pasa por ${esc(-Number(sa.quedan))})` : ''}${
      sa.provisorio ? ' (provisorios)' : ''} · ${esc(sa.aprobados)} aprobados, ${esc(sa.pedidos)} pedidos sin aprobar.${
      partes ? `<br>Lo que queda: ${partes} <span class="hint">(se gasta primero lo acumulado)</span>` : ''}</span>`;
};
const listaAvisos = (av: any[]) => (av || []).length
  ? `<ul class="avisos-vac">${av.map((a: any) => `<li>${esc(a.texto)}</li>`).join('')}</ul>` : '';
const quienYCuando = (p: any) => {
  const partes: string[] = [];
  if (p.directo) partes.push(`Cargada por ${p.cargado_por}`);
  if (p.resuelto_por && p.estado !== 'retirada') partes.push(`${p.estado === 'aprobada' ? 'Aprobó' : p.estado === 'rechazada' ? 'Rechazó' : 'Canceló'} ${p.resuelto_por}`);
  if (p.motivo) partes.push(`Motivo: ${p.motivo}`);
  if (p.comentario) partes.push(`Comentario: ${p.comentario}`);
  return partes.length ? `<div class="hint">${esc(partes.join(' · '))}</div>` : '';
};

//  El formulario de pedir y el de cargar directo comparten la forma:
//  prefijo «vp» (lo mío) o «vd» (para otra persona).
const tipoDe = (pre: string) =>
  (document.querySelector<HTMLInputElement>(`input[name="${pre}Tipo"]:checked`)?.value) || 'vacaciones';
const datosDe = (pre: string) => {
  const tipo = tipoDe(pre);
  return { tipo, desde: $(`#${pre}Desde`).value || '', hasta: tipo === 'dia' ? null : ($(`#${pre}Hasta`).value || ''),
           comentario: ($(`#${pre}Comentario`).value || '').trim() };
};
const ajustarTipo = (pre: string) => {
  const dia = tipoDe(pre) === 'dia';
  $(`#${pre}HastaLbl`).classList.toggle('oculto', dia);
  //  La enfermedad de un solo día: sin «hasta» (D227).
  $(`#${pre}HastaOpc`).classList.toggle('oculto', tipoDe(pre) !== 'enfermedad');
  $(`#${pre}DesdeTxt`).textContent = dia ? 'El día' : 'Desde';
};
const paraDe = (pre: string): number | null => pre === 'vd' ? (Number($('#vdPara').value) || null) : null;

//  Lo que diría el pedido: los días, el saldo y los avisos. No guarda nada.
async function revisar(pre: 'vp' | 'vd'){
  const caja = `#${pre}Revision`;
  const d = datosDe(pre);
  if (!d.desde || (d.tipo === 'vacaciones' && !d.hasta) || (pre === 'vd' && paraDe(pre) == null)){ limpiar(caja); return; }
  //  Sin «hasta», la enfermedad es de un día (lo decide la base).
  const turno = ++TURNO_REV[pre];
  const { data, error } = await rpcLee('revisar_vacaciones', { p_usuario_id: paraDe(pre) as any, p_datos: d as any });
  if (turno !== TURNO_REV[pre]) return;
  if (error){ aviso(caja, 'bad', error.message); return; }
  const r: any = data || {};
  const quien = pre === 'vp' ? 'te' : 'le';
  const cab = r.tipo === 'enfermedad'
    ? `<b>${esc(r.dias)} ${Number(r.dias) === 1 ? 'día' : 'días'}</b> de enfermedad: no descuentan vacaciones.`
    : `<b>${esc(r.dias)} ${Number(r.dias) === 1 ? 'día' : 'días'}</b> corridos. ${saldoTexto(r.saldo, quien)}`;
  if ((r.avisos || []).length)
    avisoHtml(caja, 'warn', `${cab}<div style="margin-top:0.353rem"><b>Avisos</b> (no frenan el pedido):</div>${listaAvisos(r.avisos)}`);
  else avisoHtml(caja, 'ok', `${cab} Sin avisos: cumple todas las condiciones.`);
}
for (const pre of ['vp', 'vd'] as const){
  $(`#${pre}Tipo`).onchange = () => { ajustarTipo(pre); revisar(pre); };
  $(`#${pre}Desde`).onchange = () => {
    ($(`#${pre}Hasta`) as unknown as HTMLInputElement).min = $(`#${pre}Desde`).value || '';
    revisar(pre);
  };
  $(`#${pre}Hasta`).onchange = () => revisar(pre);
}
$('#vdPara').onchange = () => revisar('vd');

function limpiarForm(pre: 'vp' | 'vd'){
  TURNO_REV[pre]++;   //  una revisión que todavía viene ya no pinta
  $(`#${pre}Desde`).value = ''; $(`#${pre}Hasta`).value = ''; $(`#${pre}Comentario`).value = '';
  ($(`#${pre}Hasta`) as unknown as HTMLInputElement).min = '';
  limpiar(`#${pre}Revision`);
}

async function mandar(pre: 'vp' | 'vd'){
  const msg = `#${pre}Msg`;
  limpiar(msg);
  //  Sin nadie elegido, la base lo tomaría como propio (lo que se pide para
  //  uno mismo): la carga directa siempre es para otra persona.
  if (pre === 'vd' && paraDe(pre) == null){ aviso(msg, 'bad', 'Elegí a quién le cargás las vacaciones.'); return; }
  const b = $(pre === 'vp' ? '#vpEnviar' : '#vdCargar'); b.disabled = true;
  const { data, error } = await rpc('pedir_vacaciones', { p_usuario_id: paraDe(pre) as any, p_datos: datosDe(pre) as any });
  b.disabled = false;
  if (noContesto(error)){
    aviso(msg, 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista antes de repetirlo.');
    leerMias(); if (aprueba()) leerAprobar(); return;
  }
  if (error){ aviso(msg, 'bad', error.message); return; }
  limpiarForm(pre);
  await Promise.all([leerMias(), aprueba() ? leerAprobar() : null]);
  aviso(msg, 'ok', (data as any).mensaje);
}
$('#formVacPedir').onsubmit = (ev: Event) => { ev.preventDefault(); mandar('vp'); };
$('#formVacDirecto').onsubmit = (ev: Event) => { ev.preventDefault(); mandar('vd'); };

function pintarMisPedidos(ps: any[]){
  $('#tblMisPedidos').innerHTML = ps.map((p: any) => `
    <tr data-ped="${p.id}">
      <td>${esc(QUE(p))}</td>
      <td>${esc(fechas(p))}${quienYCuando(p)}</td>
      <td class="num">${esc(p.dias)}</td>
      <td>${chipEstado(p.estado)}${p.estado === 'pedida' ? listaAvisos(p.avisos) : ''}</td>
      <td>${p.estado === 'pedida' ? `<button class="b b-sec" type="button" data-retirar="${p.id}">Retirar</button>` : ''}</td>
    </tr>`).join('') || '<tr><td colspan="5" class="vacio">Todavía no pediste vacaciones (ni este año ni para adelante).</td></tr>';
}
$('#tblMisPedidos').onclick = async (ev: Event) => {
  const b = el(ev.target).closest('[data-retirar]');
  if (!b) return;
  limpiar('#misPedMsg');
  if (!confirm('¿Retirar este pedido?')) return;
  b.disabled = true;
  const { data, error } = await rpc('cancelar_vacaciones', { p_pedido_id: Number(b.dataset.retirar) });
  b.disabled = false;
  if (noContesto(error)){ aviso('#misPedMsg', 'warn', error.message + ' No se sabe si se retiró: fijate en la lista.'); leerMias(); return; }
  if (error){ aviso('#misPedMsg', 'bad', error.message); return; }
  await Promise.all([leerMias(), aprueba() ? leerAprobar() : null]);
  aviso('#misPedMsg', 'ok', (data as any).mensaje);
};

// ---------- quien aprueba ----------
async function leerAprobar(){
  const turno = ++TURNO_APROBAR;
  const sel = $('#vapAnio');
  if (!sel.options.length){
    const a = hoyAnio();
    sel.innerHTML = [a - 1, a, a + 1].map(x => `<option value="${x}"${x === a ? ' selected' : ''}>${x}</option>`).join('');
  }
  const { data, error } = await rpcLee('vacaciones_aprobaciones', { p_anio: Number(sel.value) });
  if (turno !== TURNO_APROBAR) return;
  if (error){
    APROBAR = null;
    contador(null);
    const m = `<p class="vacio">No se pudieron leer los pedidos de vacaciones (${esc(error.message)}). No quiere decir que no haya.</p>`;
    $('#tblVacPendientes').innerHTML = `<tr><td colspan="6">${m}</td></tr>`;
    $('#tblVacResueltos').innerHTML = `<tr><td colspan="6">${m}</td></tr>`;
    return;
  }
  APROBAR = data;
  pintarAprobar();
}

//  EL NÚMERO EN LA PESTAÑA (sesión 172, D228): los pedidos que esperan y que
//  esta persona puede resolver (los suyos no: los resuelve otro). Sale de la
//  misma lectura de `vacaciones_aprobaciones`, que `entrar()` ya hace al
//  arrancar: no se guarda nada ni se consulta de más. Con 0 no se muestra;
//  si la lectura falló, «?» y NO 0 (como el contador de Avisos: un cero es
//  un número leído, y acá no se leyó). Sin `vacaciones.aprobar`, nada.
function contador(n: number | null){
  const ver = aprueba() && n !== 0;
  //  Oculto, vacío: el texto del botón de la pestaña no lleva un «0» escondido.
  const t = !ver ? '' : n === null ? '?' : String(n);
  const tit = n === null ? 'No se pudieron leer los pedidos de vacaciones'
            : `${n} ${n === 1 ? 'pedido espera' : 'pedidos esperan'} tu aprobación`;
  for (const c of ['#vacPendN', '#masVacN']){
    const e = $(c);
    e.textContent = t;
    e.title = tit;
    e.classList.toggle('oculto', !ver);
  }
}
$('#vapAnio').onchange = () => leerAprobar();

const yoId = () => Number(YO?.id);
function pintarAprobar(){
  const pend = APROBAR.pendientes || [];
  contador(pend.filter((p: any) => Number(p.usuario_id) !== yoId()).length);
  $('#tblVacPendientes').innerHTML = pend.map((p: any) => `
    <tr data-ped="${p.id}">
      <td><b>${esc(p.nombre)}</b></td>
      <td>${esc(QUE(p))}</td>
      <td>${esc(fechas(p))}${quienYCuando(p)}</td>
      <td class="num">${esc(p.dias)}</td>
      <td>${(p.avisos || []).length ? listaAvisos(p.avisos) : '<span class="chip c-ok">sin avisos</span>'}</td>
      <td>${Number(p.usuario_id) === yoId() ? '<span class="hint">Es tuyo: lo resuelve otra persona.</span>' : `<div class="fila-acc">
        <button class="b b-pri" type="button" data-aprobar="${p.id}">Aprobar</button>
        <button class="b b-sec" type="button" data-rechazar="${p.id}">Rechazar</button></div>`}</td>
    </tr>`).join('') || '<tr><td colspan="6" class="vacio">No hay pedidos esperando.</td></tr>';
  const res = APROBAR.resueltos || [];
  $('#tblVacResueltos').innerHTML = res.map((p: any) => `
    <tr data-ped="${p.id}">
      <td><b>${esc(p.nombre)}</b></td>
      <td>${esc(QUE(p))}</td>
      <td>${esc(fechas(p))}${quienYCuando(p)}</td>
      <td class="num">${esc(p.dias)}</td>
      <td>${chipEstado(p.estado)}</td>
      <td>${p.estado === 'aprobada' && Number(p.usuario_id) !== yoId()
        ? `<button class="b b-sec" type="button" data-cancelar="${p.id}">Cancelar</button>` : ''}</td>
    </tr>`).join('') || `<tr><td colspan="6" class="vacio">No hay pedidos resueltos en ${esc(APROBAR.anio)}.</td></tr>`;
  //  Para cargar directo: los demás empleados, con lo que les queda.
  const ya = $('#vdPara').value;
  $('#vdPara').innerHTML = '<option value="">— elegí —</option>' + (APROBAR.empleados || [])
    .filter((e: any) => Number(e.id) !== yoId())
    .map((e: any) => `<option value="${e.id}"${String(e.id) === ya ? ' selected' : ''}>${esc(e.nombre)} (de ${esc(e.saldo?.anio)} le quedan ${esc(e.saldo?.quedan)})</option>`).join('');
}

const pendienteDe = (id: number) => (APROBAR?.pendientes || []).find((p: any) => Number(p.id) === id);
$('#tblVacPendientes').onclick = async (ev: Event) => {
  const ap = el(ev.target).closest('[data-aprobar]');
  const re = el(ev.target).closest('[data-rechazar]');
  const b = ap || re;
  if (!b) return;
  limpiar('#vacPendMsg');
  const id = Number(ap ? ap.dataset.aprobar : re.dataset.rechazar);
  const p = pendienteDe(id);
  let motivo: string | null = null;
  if (re){
    motivo = prompt(`Rechazar ${QUE(p ?? {}).toLowerCase()} de ${p?.nombre ?? ''} (${p ? fechas(p) : ''}). ¿Por qué? Se le muestra a la persona.`);
    if (motivo == null) return;
  }
  b.disabled = true;
  const { data, error } = await rpc('resolver_vacaciones', { p_pedido_id: id, p_aprobar: !!ap, p_motivo: motivo as any });
  b.disabled = false;
  if (noContesto(error)){ aviso('#vacPendMsg', 'warn', error.message + ' No se sabe si quedó: fijate en la lista.'); leerAprobar(); leerMias(); return; }
  if (error){ aviso('#vacPendMsg', 'bad', error.message); return; }
  await Promise.all([leerAprobar(), leerMias()]);
  aviso('#vacPendMsg', 'ok', (data as any).mensaje);
};
$('#tblVacResueltos').onclick = async (ev: Event) => {
  const b = el(ev.target).closest('[data-cancelar]');
  if (!b) return;
  limpiar('#vacResMsg');
  const id = Number(b.dataset.cancelar);
  const p = (APROBAR?.resueltos || []).find((x: any) => Number(x.id) === id);
  const motivo = prompt(`Cancelar ${QUE(p ?? {}).toLowerCase()} de ${p?.nombre ?? ''} (${p ? fechas(p) : ''}), ya aprobadas. ¿Por qué? Queda escrito.`);
  if (motivo == null) return;
  b.disabled = true;
  const { data, error } = await rpc('cancelar_vacaciones', { p_pedido_id: id, p_motivo: motivo });
  b.disabled = false;
  if (noContesto(error)){ aviso('#vacResMsg', 'warn', error.message + ' No se sabe si se canceló: fijate en la lista.'); leerAprobar(); leerMias(); return; }
  if (error){ aviso('#vacResMsg', 'bad', error.message); return; }
  await Promise.all([leerAprobar(), leerMias()]);
  aviso('#vacResMsg', 'ok', (data as any).mensaje);
};

// ---------- paso 3 (D227): el calendario del mes ----------
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
let CAL_MES: { anio: number; mes: number } | null = null;
let TURNO_CAL = 0;
const TIPO_CAL: Record<string, string> = { vacaciones: 'vacaciones', dia: 'día suelto', enfermedad: 'enfermedad', ausencia: 'ausencia' };
const clsCal = (x: any) => x.tipo === 'enfermedad' || x.tipo === 'ausencia' ? 'c-bad' : x.estado === 'pedida' ? 'c-warn' : 'c-ok';
const estadoCal = (x: any) => x.estado === 'pedida' ? 'pedida, sin aprobar' : 'aprobada';
//  En el teléfono (D232) la grilla no da para los nombres: cada chip lleva
//  también un nombre CORTO (`data-corto`) y la hoja de estilos muestra ése
//  debajo de 860 px. El texto del chip sigue siendo el nombre entero (lo leen
//  el lector de pantalla y el `title`).
const chipCal = (x: any, corto: Map<string, string>) => {
  const det = `${x.nombre}: ${TIPO_CAL[x.tipo] ?? x.tipo}, ${estadoCal(x)} (${fechas(x)})`;
  return `<span class="chip ${clsCal(x)}" title="${esc(det)}" data-corto="${esc(corto.get(x.nombre) ?? x.nombre)}">${esc(x.nombre)}</span>`;
};
//  Los nombres cortos del mes: las iniciales («Otra persona» → «OP»; una
//  sola palabra, sus tres primeras letras). Si dos personas del mes quedan
//  iguales, se alarga a «Otra P.» y, si aún chocan, va el nombre entero:
//  nunca dos personas con el mismo corto.
function nombresCortos(nombres: string[]): Map<string, string> {
  const unicos = [...new Set(nombres)];
  const pal = (n: string) => n.trim().split(/\s+/).filter(x => x);
  const formas: ((n: string) => string)[] = [
    n => { const p = pal(n); return p.length > 1 ? p.slice(0, 2).map(x => x[0].toUpperCase()).join('') : p.join('').slice(0, 3); },
    n => { const p = pal(n); return p.length > 1 ? `${p[0]} ${p[1][0].toUpperCase()}.` : n; },
    n => n,
  ];
  const res = new Map<string, string>();
  let quedan = unicos;
  for (const f of formas){
    const cuenta = new Map<string, number>();
    for (const n of quedan) cuenta.set(f(n), (cuenta.get(f(n)) ?? 0) + 1);
    //  El nombre entero ya es único: la última forma se queda con todos.
    const ultima = f === formas[formas.length - 1];
    quedan = quedan.filter(n => {
      if (ultima || cuenta.get(f(n)) === 1){ res.set(n, f(n)); return false; }
      return true;
    });
  }
  return res;
}
//  El día elegido (tocándolo): debajo de la grilla, quién falta ese día.
let CAL_DIA: string | null = null;
const DIAS_SEM = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
let CAL_DATOS: { aus: any[]; bloq: any[] } = { aus: [], bloq: [] };
function pintarDia(){
  const caja = $('#calVacDia');
  $('#calVac').querySelectorAll('td[data-dia]').forEach(td => {
    const elegido = (td as HTMLElement).dataset.dia === CAL_DIA;
    td.classList.toggle('elegido', elegido);
    td.querySelector('button.num-dia')?.setAttribute('aria-pressed', String(elegido));
  });
  if (!CAL_DIA || !$('#calVac').querySelector(`td[data-dia="${CAL_DIA}"]`)){
    CAL_DIA = null; caja.classList.add('oculto'); caja.innerHTML = ''; return;
  }
  const iso = CAL_DIA;
  const ese = CAL_DATOS.aus.filter((x: any) => x.desde <= iso && x.hasta >= iso);
  const bl = CAL_DATOS.bloq.filter((b: any) => b.desde <= iso && b.hasta >= iso);
  const nombreDia = DIAS_SEM[new Date(iso + 'T00:00:00Z').getUTCDay()];
  caja.innerHTML = `<b>${nombreDia} ${esc(ddmmaaaa(iso))}</b>${(ese.length || bl.length) ? `<ul class="avisos-vac">${[
    ...ese.map((x: any) => `<li><span class="chip ${clsCal(x)}">${esc(x.nombre)}</span> ${esc(TIPO_CAL[x.tipo] ?? x.tipo)}, ${
      esc(estadoCal(x))} (${esc(fechas(x))})</li>`),
    ...bl.map((b: any) => `<li>Sin vacaciones${(b.grupos || []).length ? ` (${esc(b.grupos.join(', '))})` : ''}${
      b.motivo ? ': ' + esc(b.motivo) : ''} (${esc(fechas(b))})</li>`),
  ].join('')}</ul>` : '<p class="vacio">Ese día no falta nadie.</p>'}`;
  caja.classList.remove('oculto');
}
const elegirDia = (td: HTMLElement | null) => {
  const iso = td?.dataset.dia;
  if (!iso) return;
  CAL_DIA = CAL_DIA === iso ? null : iso;   //  tocarlo de nuevo lo cierra
  pintarDia();
};
//  Se toca en cualquier parte del día. Con el teclado, el número del día es
//  un botón de verdad (Enter y Espacio, y el lector de pantalla lo anuncia
//  con su fecha y si está elegido); la celda sigue siendo celda.
$('#calVac').addEventListener('click', e => elegirDia((e.target as HTMLElement).closest('td[data-dia]')));

async function leerCalendario(){
  const turno = ++TURNO_CAL;
  const { data, error } = await rpcLee('vacaciones_calendario', CAL_MES ? { p_anio: CAL_MES.anio, p_mes: CAL_MES.mes } : {});
  if (turno !== TURNO_CAL) return;
  if (error){
    $('#calVac').innerHTML = `<tr><td><p class="vacio">No se pudo leer el calendario (${esc(error.message)}). No quiere decir que no falte nadie.</p></td></tr>`;
    limpiar('#calVacLista');
    CAL_DATOS = { aus: [], bloq: [] };
    pintarDia();
    return;
  }
  const c: any = data || {};
  CAL_MES = { anio: Number(c.anio), mes: Number(c.mes) };
  $('#calVacMes').textContent = `${MESES[CAL_MES.mes - 1]} ${CAL_MES.anio}`;
  $('#calVacQuien').textContent = c.todos ? 'Todos los empleados.'
    : (c.personas || []).length > 1 ? 'Vos y la gente de tus grupos de cobertura.'
    : 'Sólo vos (no hay más gente en tus grupos de cobertura).';
  const aus = c.ausencias || [], bloq = c.bloqueos || [];
  CAL_DATOS = { aus, bloq };
  const corto = nombresCortos(aus.map((x: any) => x.nombre));
  const primero = new Date(Date.UTC(CAL_MES.anio, CAL_MES.mes - 1, 1));
  const largo = new Date(Date.UTC(CAL_MES.anio, CAL_MES.mes, 0)).getUTCDate();
  const antes = (primero.getUTCDay() + 6) % 7;   //  la semana empieza el lunes
  const celdas: string[] = [];
  for (let i = 0; i < antes; i++) celdas.push('<td class="fuera"></td>');
  for (let d = 1; d <= largo; d++){
    const iso = `${CAL_MES.anio}-${String(CAL_MES.mes).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
    const ese = aus.filter((x: any) => x.desde <= iso && x.hasta >= iso);
    const bl = bloq.filter((b: any) => b.desde <= iso && b.hasta >= iso);
    const cls = [iso === c.hoy ? 'hoy' : '', bl.length ? 'bloq' : ''].filter(x => x).join(' ');
    const tit = bl.map((b: any) => `Sin vacaciones${(b.grupos || []).length ? ` (${b.grupos.join(', ')})` : ''}${b.motivo ? ': ' + b.motivo : ''}`).join(' · ');
    const nombreDia = `${DIAS_SEM[new Date(iso + 'T00:00:00Z').getUTCDay()]} ${ddmmaaaa(iso)}`;
    celdas.push(`<td data-dia="${iso}"${cls ? ` class="${cls}"` : ''}${tit ? ` title="${esc(tit)}"` : ''}>
      <button type="button" class="num-dia" aria-pressed="false" aria-label="${esc(nombreDia)}">${d}</button>${ese.map((x: any) => chipCal(x, corto)).join('')}</td>`);
  }
  while (celdas.length % 7) celdas.push('<td class="fuera"></td>');
  const filasCal: string[] = [];
  for (let i = 0; i < celdas.length; i += 7) filasCal.push(`<tr>${celdas.slice(i, i + 7).join('')}</tr>`);
  $('#calVac').innerHTML = `<thead><tr>${['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'].map(x => `<th>${x}</th>`).join('')}</tr></thead>
    <tbody>${filasCal.join('')}</tbody>`;
  pintarDia();   //  el día elegido sigue abierto si es de este mes
  //  La misma información en lista (en el teléfono los nombres no entran).
  $('#calVacLista').innerHTML = (aus.length || bloq.length) ? `<ul class="avisos-vac">${[
    ...aus.map((x: any) => `<li><b>${esc(x.nombre)}</b>: ${esc(TIPO_CAL[x.tipo] ?? x.tipo)}, ${esc(fechas(x))}${
      x.estado === 'pedida' ? ' <span class="chip c-warn">pedida, sin aprobar</span>' : ''}</li>`),
    ...bloq.map((b: any) => `<li>Sin vacaciones ${esc(fechas(b))}${(b.grupos || []).length ? ` (${esc(b.grupos.join(', '))})` : ''}${
      b.motivo ? ': ' + esc(b.motivo) : ''}</li>`),
  ].join('')}</ul>` : `<p class="vacio">En ${esc(MESES[CAL_MES.mes - 1])} no falta nadie.</p>`;
}
const moverMes = (n: number) => {
  const base = CAL_MES ?? { anio: new Date().getFullYear(), mes: new Date().getMonth() + 1 };
  const d = new Date(Date.UTC(base.anio, base.mes - 1 + n, 1));
  CAL_MES = { anio: d.getUTCFullYear(), mes: d.getUTCMonth() + 1 };
  leerCalendario();
};
$('#calVacAnt').onclick = () => moverMes(-1);
$('#calVacSig').onclick = () => moverMes(1);
